import { render, staticRenderFns } from "./Masks.vue?vue&type=template&id=6c63a4b8&scoped=true&"
import script from "./Masks.vue?vue&type=script&lang=js&"
export * from "./Masks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63a4b8",
  null
  
)

export default component.exports